export const enumContextFormationThumbnail = {
    ACCUEIL : "formation-accueil",
    RECHERCHE : "formation-recherche",
    FAVORI : "formation-favori"
}